// extracted by mini-css-extract-plugin
export default {"Input":"LocationInput_Input__RFdCg"};